import { PartnerSectionProps } from "@/src/sections/partner";

export const partnersSectionData_en: PartnerSectionProps = {
  sectionHeading: {
    subtitle: "Our Partner",
    title: "Our strategic alliances",
  },
  cards: Array.from({ length: 30 }, (_, index) => ({
    img: `/assets/images/partnerbasic/partner${index + 1}.webp`,
  })),
};
